import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	enableBackground: "new 0 0 400 200",
	viewBox: "0 0 400 200",
	xmlns: "https://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m44.8 43.4v149.1l-37.6-37.7v-110.4l36.9-36.9h55.2l36.9 36.9v16.3l-37.9 37.6v-55zm91.4 91.8v56.2h-37.7l-.3-57h-16.2l-36.1-36.1h53.4z",
			fill: "#48c9b0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m44.8 54.2-37.6-9.8 1-1h36.6zm53.5-10.8h-10.9l9.3-35.9h1.5zm37.1 91 .8.8-37.9 10.1v-10.8h37.1z",
			fill: "#16a085"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#2c3e50",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "m249.3 141.8h-26.7l-20.2-31.7h-.2v31.7h-21.4v-82.5h32c16.3 0 28.7 7.8 28.7 25.4 0 11.4-6.3 21.2-18.1 23.3zm-47.2-45.5h2.1c7 0 14.9-1.3 14.9-10.3s-7.9-10.3-14.9-10.3h-2.1z" }),
				/* @__PURE__ */ _jsx("path", { d: "m309.6 117.1h-41.9c0 8.1 4.3 12.5 12.5 12.5 4.3 0 7.3-1.4 9.5-5.1h19.1c-3.2 13.2-15.8 19.3-28.5 19.3-18.6 0-32.5-10.5-32.5-29.9 0-18.7 12.8-30 31.1-30 19.5 0 30.7 12 30.7 31.2zm-18.5-11.5c-1-5.4-5.9-8.9-11.3-8.9-5.8 0-10.6 3.1-11.8 8.9z" }),
				/* @__PURE__ */ _jsx("path", { d: "m367.1 125.3v16.5h-56.9l26.4-39.6h-22.9v-16.5h56l-26.3 39.6z" }),
				/* @__PURE__ */ _jsx("path", { d: "m395.4 64.1c0 6.1-5 11.2-11.2 11.2s-11.2-5-11.2-11.2c0-6.1 5-11.2 11.2-11.2s11.2 5.1 11.2 11.2zm-1.2 77.7h-19.9v-56.1h19.9z" })
			]
		})
	]
});
export { SvgLogoDark as ReactComponent };
